import {
  getEmptyContent,
  isDisplay,
  isValidData,
  WelcomeTour
} from '@com-delta-idp/mnx-skymiles-shared';
import {
  AnalyticsEvent,
  logError,
  triggerCustomEvent
} from '@com-delta-idp/mnx-utils';
import { AEMWelcomeTourContent } from '../models';

export const getWelcomeTour = (
  tour: AEMWelcomeTourContent | undefined,
  featureFlag: boolean | undefined
): WelcomeTour => {
  try {
    return isValidData<
      AEMWelcomeTourContent,
      [AEMWelcomeTourContent | undefined, boolean | undefined]
    >('header', tour, featureFlag) && Array.isArray(tour?.slides)
      ? adaptWelcomeTour(tour as AEMWelcomeTourContent, featureFlag as boolean)
      : isDisplay<WelcomeTour>(featureFlag);
  } catch (error) {
    logError(error as Error, 'SKYMILES', 'SHARED', 'WELCOME_TOUR');
    return getEmptyContent<WelcomeTour>('', [], true, true);
  }
};

const adaptWelcomeTour = (
  tour: AEMWelcomeTourContent,
  featureFlag: boolean
): WelcomeTour => {
  const display = validateDisplayStatus(featureFlag, tour.analyticsEvent);
  if (display) {
    return {
      slides: tour.slides,
      header: tour.header,
      disabled: !display,
      loaded: true,
      analyticsEvent: tour.analyticsEvent,
      ariaLabels: {
        close: tour.ariaLabels.closeTour,
        action: tour.ariaLabels.action
      }
    };
  } else {
    return getEmptyContent<WelcomeTour>();
  }
};

const validateDisplayStatus = (
  featureFlag: boolean,
  event: AnalyticsEvent
): boolean => {
  const display: boolean = getDisplayStatus() && featureFlag;

  if (display) {
    triggerCustomEvent<string>(event.name, event.value);
  }

  return display;
};

const getDisplayStatus = (): boolean => {
  const display = JSON.parse(
    localStorage.getItem('welcomeTourModal') as string
  );

  return !!(display === null || display);
};
